import { render } from "./QAPage.vue?vue&type=template&id=ffc4479e&scoped=true"
import script from "./QAPage.vue?vue&type=script&lang=js"
export * from "./QAPage.vue?vue&type=script&lang=js"

import "./QAPage.vue?vue&type=style&index=0&id=ffc4479e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffc4479e"]])

export default __exports__